import { createGlobalStyle } from "styled-components";
import { ColorVariables } from "../Colors";
import { getMobileBreakpoint, globalCSSVars } from "./globals";

const InputCSS = createGlobalStyle`
  
  input[type='text'],
  input[type='number'],
  input[type='password'],
  input[type='tel'],
  input[type='date'],
  textarea {
    font-family: inherit;
    font-size: 16px !important;
    line-height: 24px !important;
    color: ${ColorVariables.coco};
    box-shadow: none;
    width: 100%;
    max-width: 600px;
    height: 56px;
    padding: 16px 36px 16px 16px;
    border-radius: 8px;
    border: solid 1px var(--manifest-coco3);
    -webkit-appearance: none; /* Removes box shadow at top for iphone */
  }
  
  input:focus, textarea:focus {
    outline: none;
  }
  
  input:read-only, textarea:read-only {
    color: ${ColorVariables.coco5};
    cursor: pointer;
  }

  textarea:not(:read-only):focus,
  input[type='text']:not(:read-only):focus,
  input[type='number']:not(:read-only):focus,
  input[type='date']:not(:read-only):focus,
  input[type='tel']:not(:read-only):focus,
  input[type='password']:not(:read-only):focus {
    border: solid 3px ${ColorVariables.mint};
  }

  input[type="date"]::-webkit-inner-spin-button,
  input[type="date"]::-webkit-calendar-picker-indicator {
    opacity: 0;
    transform: translateX(30px); /* Helps offset the calendar to the icon we use */
    -webkit-appearance: none;
  }
  
  button {
    cursor: pointer;
    font-family: inherit;
    background-color: transparent;
    border: none;
    outline: none;
    padding: 0px;
    width: 100%;
    max-width: 600px;
    border-radius: 10px;
  }

  button:disabled {
    pointer-events: none;
    cursor: initial;
  }
  
  /*
    MEDIA QUERIES
  */
  
  @media (max-width: ${getMobileBreakpoint}) {
    input {
      max-width: ${globalCSSVars.mobileWidth};
      height: 52px;
      padding: 14px 36px 14px 14px;
      border-radius: 8px;
      border: solid 2px #eae2db;
      &.isSmall {
        height: 32px;
      }
    }
    
    input[type="number"] {
      padding: 14px 7px 14px 14px !important;
    }
  
    .radio-container {
      margin: 4px 2px;
    }
  
    button {
      max-width: ${globalCSSVars.mobileWidth};
    }
  }
  .single-label {
    color: ${ColorVariables.coco5};
    font-weight: 400;
    padding-left: 12px;
    margin-bottom: 12px;
  }
  .single-label-content {
    padding-left: 12px;
  }
`;

export default InputCSS;
